module.exports = __webpack_public_path__ + "img/MED_HIGH_GLYCEMIC@300x.c10e11f3.png";